import { Component, input, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { Section, TextAreaContent } from 'app/_shared/interfaces/config'

@Component({
    selector: 'app-text-editor',
    imports: [],
    templateUrl: './text-editor.component.html',
    styleUrl: './text-editor.component.scss'
})
export class TextEditorComponent implements OnInit {
  section = input.required<Section<TextAreaContent>>()
  trustedHtml: SafeHtml

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.trustedHtml = this.sanitizer.bypassSecurityTrustHtml(this.section()?.content?.text ?? '')
  }
}
